import { registerPlugin } from '@capacitor/core';

import { ApplePayPlugin as ApplePayPluginInterface } from './apple-pay-plugin.types';

export const ApplePayPlugin = registerPlugin<ApplePayPluginInterface>('ApplePay', {
  web: () => import('./apple-pay-plugin.web').then((m) => new m.ApplePayPluginWeb()),
  android: () => import('./apple-pay-plugin.android').then((m) => new m.ApplePayPluginAndroid()),
});
